export enum ReferenceEnum {
  DEPARTMENT = 'department',
  FACULTY = 'faculty',
  LGA = 'lga',
  STATE = 'state',
  COUNTRY = 'country',
  LEVEL = 'level',
  RELIGION = 'religion',
  MARITALSTATUS = 'maritalstatus',
  GENOTYPE = 'genotype',
  COURSEOPTION = 'courseoption',
  BLOODGROUP = 'bloodgroup',
  GENDER = 'gender',
  SEX = 'sex',
  ENTRYMODE = 'entrymode',
  SESSION = 'session',
  PROGRAMMETYPE = 'programmetype',
  EMAIL = 'email',
  DATEOFBIRTH = 'dateofbirth',
  CANDIDATEREGNO = 'candidateregno',
  PHONE = 'phone',
  CANDNAME = 'candname',
  REGNUMB = 'regnumb',
  COURSE = 'course',
  STATEOFORIGIN = 'stateoforigin',
  CERTIFICATETYPE = 'certificatetype',
}
